import { TranslationKey } from './../../../../types/translation/TranslationKey';
import React from 'react';
import { Alert } from '../../../../types/alert';
import { BinStatus } from '../../../../types/bin/binStatus';
import { ProductMasterData } from '../../../../types/product_master_data/productMasterData';
import { t } from '../../../../types/translation/Translator';
import { itemsContainText } from '../../../../util/string.util';
import { BaseFilter } from '../common/BaseFilter';
import { DateTimeFilter } from '../DateTimeFilter';
import { FilterStorageKey, FilterProps } from '../common/filter.util';
import { LotFilter } from '../LotFilter';
import { ProductMasterDataFilter } from '../ProductMasterDataFilter';
import { TagRelation } from '../../../../types/tag/tagRelation';
import { CustomFieldFilter } from '../CustomFieldFilter';
import { CustomField, CustomFieldEntityType } from '../../../../types/custom_field/customField';
import { Lot } from '../../../../types/lot';
import { TriggerEntityType } from '../../../../types/trigger';
import { Company } from '../../../../types/company';

export class AlertFilter extends BaseFilter<Alert> {
  productMasterData: Map<string, ProductMasterData>;
  binStatuses: Map<string, BinStatus>;
  tagRelations: Map<string, TagRelation>;
  lots: Map<string, Lot>;
  customFields: Map<string, CustomField>;
  company: Company;

  constructor(
    productMasterData: Map<string, ProductMasterData>,
    binStatuses: Map<string, BinStatus>,
    tagRelations: Map<string, TagRelation>,
    lots: Map<string, Lot>,
    customFields: Map<string, CustomField>,
    company: Company,
  ) {
    super(FilterStorageKey.ALERT);
    this.binStatuses = binStatuses;
    this.productMasterData = productMasterData;
    this.tagRelations = tagRelations;
    this.lots = lots;
    this.customFields = customFields;
    this.company = company;
  }

  toLabel(): string {
    return t(TranslationKey.alert).singular.label;
  }

  filterOptions = () => [
    new DateTimeFilter(),
    new ProductMasterDataFilter(this.customFields, this.tagRelations, this.company),
    new LotFilter(this.productMasterData, this.customFields, this.lots, this.tagRelations, this.company),
    ...CustomFieldFilter.for(CustomFieldEntityType.productMasterData, this.productMasterData, this.customFields),
    ...CustomFieldFilter.for(CustomFieldEntityType.lot, this.lots, this.customFields),
  ];

  toCount(): number {
    return 0;
  }

  toIcon(): JSX.Element {
    return <></>;
  }

  toDropdownContent(): JSX.Element {
    return <></>;
  }

  toInnerContent(): string | JSX.Element {
    return <></>;
  }

  search(item: Alert, filter: string) {
    return itemsContainText(filter, [item.alertString]);
  }

  filteredItems(items: Alert[], query: string, filterProps: FilterProps) {
    return items.filter(item => {
      const productMasterData =
        item.entityType === TriggerEntityType.pmd ? this.productMasterData.get(item.triggeredValue || '') : undefined;
      const lot = item.entityType === TriggerEntityType.lot ? this.lots.get(item.triggeredValue || '') : undefined;

      return [
        DateTimeFilter.filter(filterProps, new Date(item.createdAt)),
        ProductMasterDataFilter.filter(filterProps, productMasterData, this.customFields, this.tagRelations),
        LotFilter.filter(filterProps, lot),
        this.search(item, query),
      ].every(value => value === null || value);
    });
  }
}
